import { Filter } from 'types/Filter';

export function getCategoryFieldIds(filter: Filter) {
  const raw = filter as Record<string, unknown>;
  const toOptionalId = (key: string): number | undefined => {
    const v = raw[key];
    if (v === undefined || v === null || v === '') return undefined;
    const n = Number(v);
    return Number.isFinite(n) ? n : undefined;
  };

  return {
    mainCategoryValue: toOptionalId('main-category'),
    subCategoryValue: toOptionalId('sub-category'),
    subSubCategoryValue: toOptionalId('sub-subcategory'),
  };
}
